import React, { FunctionComponent } from 'react';

import { i18n } from '../../../../../../helpers/i18n';
import { Heading } from '../../heading';
import { Island } from '../../island';
import { DoNotCheckDesktopAppExistenceTumbler } from '../../tumblers';
import css from './styles.css';

export const DevelopSection: FunctionComponent = () => {
    return (
        <Island className={css.developWrapper}>
            <Heading title={i18n('settings-v2', 'section-develop-title')} />
            <DoNotCheckDesktopAppExistenceTumbler />
        </Island>
    );
};
